import { rest, setupWorker } from 'msw';
import { getConfig } from 'shared/config';
import { handlers } from './handlers';

export const worker = setupWorker(...handlers);
export const workerOptions = {
  onUnhandledRequest(req) {
    const isODIN = req.url.origin.startsWith(getConfig().odin?.host);
    // don't log with ODIN warnings
    if (isODIN) return;

    const isMicroservice = req.url.origin.startsWith(getConfig().microServices?.host);
    if (isMicroservice)
      console.error(
        'Found an unhandled %s request to %s - add it inside of handlers.ts',
        req.method,
        req.url.href,
      );
  },
};

declare global {
  interface Window {
    msw: {
      worker: typeof worker;
      rest: typeof rest;
    };
  }
}
